import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";
import PrescriptionModal from "../modalComp/PrescriptionModal";

const formatRupiah = (number) => {
  return number ? Number(number).toLocaleString("id-ID") : 0;
};

const SwipeDetailConsultation = ({ open, setOpen, data }) => {
  const [openModalDetail, setOpenModalDetail] = useState(false);

  const handleOpenDetail = () => {
    setOpen(false);
    setOpenModalDetail(true);
  };

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 z-[999]"
            onClick={() => setOpen(false)}
          />

          <motion.div
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl z-[9999] max-h-[70vh] flex flex-col shadow-2xl text-base"
          >
            <div className="flex flex-col gap-3 py-2 px-3">
              <div className="flex w-full justify-center">
                <div className="bg-gray-200 w-[25%] h-1.5 rounded-full"></div>
              </div>
              <h2 className="text-lg font-semibold text-slate-900">Resep</h2>
            </div>

            <div className="flex-1 p-3 overflow-y-auto">
              <div className="flex flex-col gap-1">
                {data && data.recipes?.length > 0 ? (
                  data.recipes?.map((item, index) => (
                    <div
                      key={index}
                      className="flex items-end justify-between gap-2"
                    >
                      <div className="text-slate-700">
                        <h1 className="font-medium text-primary">
                          {item.product_name}
                        </h1>
                        <p className="text-slate-500 text-sm tabular-nums">
                          {item.quantity}x Rp{formatRupiah(item.price)}
                        </p>
                      </div>
                      <div className="font-semibold text-error tabular-nums">
                        Rp{formatRupiah(item.total)}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-slate-500">
                    <p>Resep dokter belum terbit</p>
                  </div>
                )}
              </div>
            </div>
            <div className="w-full rounded-t-3xl flex items-center gap-2 px-3 py-4">
              <button
                onClick={() => setOpen(false)}
                className="h-[40px] border border-secondary flex items-center justify-center bg-white text-secondary w-full tracking-wide font-medium rounded-lg focus:outline-none focus:shadow-outline hover:bg-secondaryHover transform duration-200 hover:scale-100 disabled:bg-slate-400 disabled:cursor-disabled"
              >
                Tutup
              </button>
              <button
                onClick={handleOpenDetail}
                className="h-[40px] border border-secondary flex items-center justify-center bg-secondary text-white w-full tracking-wide font-medium rounded-lg focus:outline-none focus:shadow-outline hover:bg-secondaryActive transform duration-200 hover:scale-100 disabled:bg-slate-400 disabled:cursor-disabled"
              >
                e-Resep
              </button>
            </div>
          </motion.div>
        </>
      )}

      <PrescriptionModal
        open={openModalDetail}
        setOpen={setOpenModalDetail}
        data={data}
      />
    </AnimatePresence>
  );
};

export default SwipeDetailConsultation;
